export default __webpack_public_path__ + "static/media/resume.cf397347.pdf";